import { memo, useCallback } from "react";

import { classNames } from "helpers";
import { Switch } from "ui/components/Switch";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

import { isInvalidWorkingDay, WAREHOUSE_TIME_OPTIONS } from "../consts";
import { WarehouseWorkingDayRowProps } from "../types";

/** Jedan dan u tjednu: radi ili ne radi, i od kada do kada. */
const WarehouseWorkingDayRow: React.FC<WarehouseWorkingDayRowProps> = ({ label, workingDay, onChange }) => {
  const isInvalid = isInvalidWorkingDay(workingDay);

  const handleOpenChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ ...workingDay, isOpen: e.target.checked });
    },
    [workingDay, onChange]
  );

  const handleTimeChange = useCallback(
    (_e: any, name: string, item: DropdownOption) => {
      onChange({ ...workingDay, [name]: item.value || null });
    },
    [workingDay, onChange]
  );

  return (
    <div
      className={classNames(
        "flex flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3 border-b border-slate-200 last:border-b-0",
        workingDay.isOpen ? "bg-white" : "bg-slate-50"
      )}
    >
      <div className="w-28 text-sm font-medium text-slate-700">{label}</div>

      <div className="w-36">
        <Switch
          name={`isOpen-${workingDay.day}`}
          checked={workingDay.isOpen}
          onChange={handleOpenChange}
          labelRight={workingDay.isOpen ? "Radi" : "Zatvoreno"}
        />
      </div>

      {workingDay.isOpen ? (
        <div className="flex flex-1 items-center gap-3 min-w-[16rem]">
          <div className="w-32">
            <Dropdown
              name="from"
              placeholder="Od"
              options={WAREHOUSE_TIME_OPTIONS}
              value={workingDay.from}
              onChange={handleTimeChange}
              height="small"
              width="full"
              cssClassName="bg-white"
            />
          </div>
          <span className="text-sm text-slate-400">do</span>
          <div className="w-32">
            <Dropdown
              name="to"
              placeholder="Do"
              options={WAREHOUSE_TIME_OPTIONS}
              value={workingDay.to}
              onChange={handleTimeChange}
              height="small"
              width="full"
              cssClassName="bg-white"
            />
          </div>
          {isInvalid && <span className="text-xs text-red-500">Kraj mora biti nakon početka</span>}
        </div>
      ) : (
        <div className="flex-1 text-sm text-slate-400">Skladište ne radi</div>
      )}
    </div>
  );
};

export default memo(WarehouseWorkingDayRow);
